import { StyleSheet } from 'react-native';
import { BLACK_300, LILAC_200, WHITE, tokens } from '@airtel/air-design-system';
export var getGraphWidgetStyles = () => {
  return StyleSheet.create({
    summaryContainer: {
      paddingTop: tokens.spacing.SPACING_16,
      paddingBottom: tokens.spacing.SPACING_16,
      backgroundColor: LILAC_200,
      borderColor: WHITE,
      borderWidth: 1,
      borderRadius: tokens.spacing.SPACING_16
    },
    calloutContainer: {
      paddingLeft: tokens.spacing.SPACING_16,
      paddingRight: tokens.spacing.SPACING_16
    },
    dividerContainer: {
      marginBottom: tokens.spacing.SPACING_16,
      marginTop: tokens.spacing.SPACING_16
    },
    infoSummaryContainer: {
      zIndex: 2,
      borderWidth: 0
    },
    dropdownContainerWrapper: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      zIndex: 1,
      paddingLeft: tokens.spacing.SPACING_16,
      paddingRight: tokens.spacing.SPACING_16,
      marginBottom: tokens.spacing.SPACING_24
    },
    dropdownContainer: {
      marginLeft: tokens.spacing.SPACING_12
    },
    no_data_available: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'row',
      gap: 8,
      alignItems: 'center',
      height: 200,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: BLACK_300,
      borderRadius: tokens.spacing.SPACING_12,
      marginLeft: tokens.spacing.SPACING_16,
      marginRight: tokens.spacing.SPACING_16
    }
  });
};